<template>
    <div class="list sell">
        <div v-if="load">
            <vue-loading style="position: fixed;z-index: 100;left: 25%;" type="spin" color="#333" :size="{ width: '50%', height: '50%' }"></vue-loading>
            <div class="over" style="opacity: 0.7;width: 100%;height: 100%;background: #fefefe;position: fixed;top: 0;left: 0;z-index: 99;"></div>
        </div>
        <div class="auctionRegister">
            <h1 class="topTitle">コメント・売上管理</h1>
            <div class="btnBox" v-if="show_type=='comment'">
                <button class="btn" @click="showOmatome" style="width: 30%;background-color: #30a14e;border: none;">おまとめ申請確認</button>
            </div>
            <div class="btnBox" v-if="show_type=='bundle'">
                <button class="btn" @click="show_type='comment'" style="width: 30%;background-color: #30a14e;border: none;">コメント確認</button>
            </div>
            <div v-show="show_type=='comment'">
            
            <div class="btnBox" v-if="!isCommentFilter">
                <button class="btn" @click="filter_comment_count">2つ以上のコメントのみ表示</button>
            </div>
            <div class="btnBox" v-if="isCommentFilter">
                <button class="btn" @click="clear_comment_filter">全て表示</button>
            </div>
            <div class="container" >
                <div class="outer-menu">
                    <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox" />
                    <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox">
                        <div v-if="isShowSerchBox"></div>
                    </div>
                    <div class="menu">
                        <div class="searchArea">
                            <div class="searchBox">
                                <h2 class="itemTitle">検索</h2> 
                                <ul>
                                    <li>
                                    <label for="itemName">出品ID:</label>
                                    <input type="text" placeholder="出品ID" id="sellId" v-model="serchItem.sellId" tabindex="1"/>
                                </li>
                                <li>
                                    <label for="itemName">商品名:</label>
                                    <input type="text" placeholder="商品名" id="itemName" v-model="serchItem.name" tabindex="1"/>
                                </li>
                                <li>
                                    <label for="itemName">ユーザー名:</label>
                                    <select class="sltBox" v-model="serchItem.userName">
                                        <option value="" disabled selected hidden>選択してください</option>
                                        <option v-for="item in userList" :value="item.USER_NAME" :key="item.USER_ID">
                                            {{ item.USER_NAME }}
                                        </option>
                                    </select>
                                    
                                </li>
                                <li class="serchDateBox">
                                    <label for="str">出品日（売買成立日）:</label>
                                    <datepicker
                                        v-model="serchItem.sellDateStr"
                                        format="yyyy年MM月dd日"
                                        placeholder="出品日（FROM）"
                                        input-class="searchDate"
                                        :language="ja"
                                        :disabled-dates="disabledDates"></datepicker>
                                    ~
                                    <datepicker
                                        v-model="serchItem.sellDateEnd"
                                        format="yyyy年MM月dd日"
                                        placeholder="出品日（TO）"
                                        input-class="searchDate"
                                        :language="ja"
                                        :disabled-dates="disabledDates"></datepicker>
                                </li>
                                <li class="serchDateBox">
                                    <label for="serchIsSelled">成約済のみ表示:</label><br>
                                <input type="checkbox" v-model="serchItem.isSelled" id="serchIsSelled" >
                                <label class="checkbox03" for="serchIsSelled"></label>
                                </li>
                                <li class="serchDateBox">
                                    <label for="price">いいね数:</label>
                                    <input class="searchDate" type="number" placeholder="いいね数（FROM）" id="good" v-model="serchItem.goodCountStr" tabindex="2"/> ~ 
                                    <input class="searchDate" type="number" placeholder="いいね数（TO）" v-model="serchItem.goodCountEnd" tabindex="2"/>
                                </li>
                                <li class="serchDateBox">
                                    <label for="price">コメント数:</label>
                                    <input class="searchDate" type="number" placeholder="コメント数（FROM）" id="price" v-model="serchItem.comCountStr" tabindex="2"/> ~ 
                                    <input class="searchDate" type="number" placeholder="コメント数（TO）" v-model="serchItem.comCountEnd" tabindex="2"/>
                                </li>
                                <li class="serchDateBox">
                                    <label for="str">最新コメント日:</label>
                                    <datepicker
                                        v-model="serchItem.comDateStr"
                                        format="yyyy年MM月dd日"
                                        placeholder="最新コメント日（FROM）"
                                        input-class="searchDate"
                                        :language="ja"
                                        :disabled-dates="disabledDates"></datepicker>
                                    ~
                                    <datepicker
                                        v-model="serchItem.comDateEnd"
                                        format="yyyy年MM月dd日"
                                        placeholder="最新コメント日（TO）"
                                        input-class="searchDate"
                                        :language="ja"
                                        :disabled-dates="disabledDates"></datepicker>
                                </li>
                            </ul>
                            <div class="btnBox">
                                <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                                <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="userBox">
                    
                </div>
                <button data-v-20acca12="" class="btn" style="line-height: 1; background-color: rgb(11, 94, 215); border-color: rgb(10, 88, 202);" @click="allCheck">
                    このページを全てチェックする
                </button>
                <div class="item-wrap">
                    <table class="itemTable">
                        <tr>
                            <th class="listTitle">
                                削除
                            </th>
                            <th class="listTitle">
                                出品者名
                            </th>
                            <th class="listTitle">
                                最新コメント日時
                            </th>
                            <th class="listTitle">
                                商品ページへ
                            </th>
                            <th class="listTitle">
                                現在出品価格
                            </th>
                            <th class="listTitle">
                                いいね数
                            </th>
                            <th class="listTitle">
                                コメント数
                            </th>
                            
                            <th class="listTitle">
                                操作
                            </th>
                        </tr>
                        <tr v-for="(item ,index) in getItems" :key="index">
                            <td class="listItem">
                                <input type="checkbox" v-model="item.deleteFlg" :id="index + ((currentPage -1) *  perPage)+'_m'" value="1">
                                <label class="checkbox03" :for="index + ((currentPage -1) *  perPage)+'_m'"></label>
                            </td>
                            
                            <td class="listItem">
                                {{item.user_name}}
                            </td>
                            <td class="listItem">
                                {{item.COMMENT_DATE}}
                            </td>
                            <td class="listItem">
                                <a class="link" :href="'https://jp.mercari.com/item/'+item.SELL_ID" target="_blank" rel="noopener noreferrer">商品ページへ移動</a>
                            </td>
                            <td class="listItem">
                                {{item.SELL_PRICE}}
                            </td>
                            <td class="listItem">
                                {{item.GOOD_COUNT}}
                            </td>
                            <td class="listItem">
                                {{item.COMMENT_COUNT}}
                            </td>
                            
                            <td class="listItem">
                                <button class="btn modif" @click="modal(item)">操作する</button>
                            </td>
                        </tr>
                        
                    </table>
                    <div>
                        <button class="btn modif" @click="delete_item">削除登録</button>
                    </div>
                    <div class="overlay" v-show="isModal">
                        <div class="modalodal">
                            <div class="swal2-popup swal2-modal swal2-show" style="display: grid;width: 100%;padding: 5px;height: 600px;overflow: auto;" >
                                <table class="itemTable">
                                    <tr>
                                        <th class="listTitle name" style="width:30%">
                                            コメント送信者名
                                        </th>
                                        <th class="listTitle name" style="width:30%">
                                            コメント送信日時
                                        </th>
                                        <th class="listTitle com">
                                            コメント
                                        </th>
                                    </tr>
                                    <!-- <div v-id="vm.tmpComList">
                                    {{vm.tmpComList.comments}}
                                    </div> -->
                                    <tr v-for="(item ,index) in tmpComList.comments" :key="index">
                                        <td class="listItem">
                                            {{item.USER_NAME}}
                                        </td>
                                        <td class="listItem">
                                            {{item.COMMENT_DATE}}
                                        </td>
                                        <td class="listItem">
                                            {{item.COMMENT}}
                                        </td>
                                    </tr>
                                </table>
                                <div>
                                    
                                    <h5 @click="mType='com'">コメントを返信する</h5>
                                    <div v-show="mType=='com'">
                                        <textarea rows="5" v-model="postItem.com"></textarea>

                                        <button class="btn modif" @click="setComment()">返信する</button>
                                    </div>
                                </div>

                                <div>
                                    <h5 @click="mType='edit'">この商品情報を変更する</h5>
                                    <div v-show="mType=='edit'">
                                        <label>
                                            商品価格
                                            <input type="text" v-model="postItem.price">
                                        </label>
                                        <label>
                                            商品名
                                            <input type="text" v-model="postItem.title">
                                        </label>
                                        <button class="btn modif" @click="editItem()">更新する</button>

                                    </div>
                                </div>
                                
                                <div class="swal2-actions">
                                <button class="swal2-cancel swal2-styled" @click="rePage">戻る</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pdgTop10">
                        <vuejs-paginate
                        :page-count="getPaginateCount"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :click-handler="paginateClickCallback"
                        :container-class="'pagination justify-content-center'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
                        :first-last-button="true"
                        :first-button-text="'<<'"
                        :last-button-text="'>>'"
                        ></vuejs-paginate>
                    </div>
                    
                </div>
                <div class="btnBox subArea">
                    <button class="btn repage" @click="returnPage">戻る</button>
                    <!-- <button class="btn submit" @click="register" :disabled="isDisabled" >登録する</button> -->
                </div>
            </div>
        </div>
        <!-- おまとめ申請一覧 -->
        <div v-show="show_type=='bundle'">
            <div class="item-wrap">
                    <table class="itemTable">
                        <tr>
                            <th class="listTitle">
                                出品者名
                            </th>
                            <th class="listTitle">
                                依頼日時
                            </th>
                            <th class="listTitle">
                                回答期限
                            </th>
                            <th class="listTitle">
                                依頼金額
                            </th>
                            <th class="listTitle">
                                操作
                            </th>
                        </tr>
                        <tr v-for="(item ,index) in getOmatomeItems" :key="index">
                            <td class="listItem">
                                {{item.user_name}}
                            </td>
                            <td class="listItem">
                                {{item.CREATE_TIME}}
                            </td>
                            <td class="listItem">
                                {{item.EXPIRE_TIME}}
                            </td>
                            <td class="listItem">
                                {{item.PRICE}}
                            </td>
                            <td class="listItem">
                                <button class="btn modif" @click="omatomeModal(item)">操作する</button>
                            </td>
                        </tr>
                        
                    </table>
                    <div class="overlay" v-show="isOmatomeModal">
                        <div class="modalodal">
                            <div class="swal2-popup swal2-modal swal2-show" style="display: grid;width: 100%;padding: 5px;height: 600px;overflow: auto;" >
                                <table class="itemTable">
                                    <tr>
                                        <th class="listTitle name" style="width:30%">
                                            商品ページ
                                        </th>
                                        <th class="listTitle name" style="width:30%">
                                            商品名
                                        </th>
                                        <th class="listTitle com">
                                            商品金額
                                        </th>
                                    </tr>
                                    <tr v-for="(item ,index) in omatomeSellList" :key="index">
                                        <td class="listItem">
                                            <a class="link" :href="'https://jp.mercari.com/item/'+item.url" target="_blank" rel="noopener noreferrer">商品ページへ移動</a>
                                        </td>
                                        <td class="listItem">
                                            {{item.name}}
                                        </td>
                                        <td class="listItem">
                                            {{item.price}}
                                        </td>
                                    </tr>
                                </table>
                                <div>
                                    <div class="brdBtm">
                                        <h3 id="shipLoad" class="itemLable">送料負担<span class="mandatory">必須</span></h3>
                                        
                                        <span v-for="item in codes.shiploadList" :key="item.CODE_ID">
                                            <input type="radio" v-model="postOmatome.M_SHIPLOAD" :id="item.CODE_ID+'_shiploadList'" :value="item.CODE_ID">
                                            <label class="radioLabel" :for="item.CODE_ID+'_shiploadList'">{{ item.CODE_NAME }}</label>
                                        </span>
                                    </div>
                                    <div class="brdBtm">
                                        <h3 id="shipSorce" class="itemLable">発送元<span class="mandatory">必須</span></h3>
                                    
                                        <select class="sltBox" v-model="postOmatome.M_SHIPSOURCE">
                                            <option value="" disabled selected hidden>選択してください</option>
                                            <option v-for="item in codes.shipsorceList" :value="item.CODE_ID" :key="item.CODE_ID">
                                                {{ item.CODE_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="brdBtm">
                                        <h3 id="shipSchedule" class="itemLable">発送日数<span class="mandatory">必須</span></h3>
                                    
                                        <select class="sltBox" v-model="postOmatome.M_SHIPSCHEDULE">
                                            <option value="" disabled selected hidden>選択してください</option>
                                            <option v-for="item in codes.shipScheduleList" :value="item.CODE_ID" :key="item.CODE_ID">
                                                {{ item.CODE_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="brdBtm">
                                        <h3 id="mShipMethod" class="itemLable">配送方法<span class="mandatory">必須</span></h3>
                                        
                                        <select class="sltBox" v-model="postOmatome.M_SHIPMETHOD">
                                            <option value="" disabled selected hidden>選択してください</option>
                                            <option v-for="item in codes.ShipMethodList" :value="item.CODE_ID" :key="item.CODE_ID">
                                                {{ item.CODE_NAME }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="swal2-actions">
                                        <button class="btn modif swal2-success swal2-styled " style="margin:5px;" @click="setOmatome('1')">承認する</button>
                                        <button class="swal2-cancel swal2-styled btn" style="margin:5px;" @click="setOmatome('2')">断る</button>
                                    </div>
                                </div>
                                <div class="swal2-actions">
                                    <button class="swal2-cancel swal2-styled" @click="hideOmakseModal">戻る</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pdgTop10">
                        <vuejs-paginate
                        :page-count="getOmatomePaginateCount"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :click-handler="omatomePaginateClickCallback"
                        :container-class="'pagination justify-content-center'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
                        :first-last-button="true"
                        :first-button-text="'<<'"
                        :last-button-text="'>>'"
                        ></vuejs-paginate>
                    </div>
                    
                </div>
        </div>
        </div>
    </div>
    
</template>
<script>
import {userRepository} from '@/Repositories/userRepository.js'
import {cApiRepsitory} from '@/Repositories/cApiRepsitory.js'
import {omatomeRepository} from '@/Repositories/omatomeRepository.js'
import {codeRepository} from '@/Repositories/codeRepository.js'
import {itemRepository} from '@/Repositories/itemRepository.js'
import {commentRepository} from '@/Repositories/commentRepository.js'

import VueJsPaginate from 'vuejs-paginate';
import { VueLoading } from 'vue-loading-template'
import Datepicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
export default {
    
  data() {
        return {
            /******************
             * Datepicker設定
            ******************/
            ja:ja,
            disabledDates:{
                from:new Date()
            },
            /******************
             * 表示フラグ
            ******************/
            isShowSerchBox:false,
            isDisabled:true,
            isModal:false,
            mType:'',
            isCommentFilter:false,
            isOmatomeModal:false,
            show_type:'comment',
            load : false,
            /******************
             * ユーザー情報
            ******************/
            userInfo:{},
            userList:[],
            setUserId:'',
            tmpSiteType:null,
            /******************
             * 商品情報
            ******************/
            auctionList:[],
            tmpAuctionList:[],
            comList:[],
            tmpComList:[],
            itemList:[],
            commentList:[],
            omatomeList:[],
            omatomeSellList:[],
            baseCode:[],
            codes:{},
            postItem:{},
            postOmatome:{},
            /******************
             * 検索ボックス
            ******************/
            serchItem : {
                sellId:null,
                name:null,
                sellDateStr:null,
                sellDateEnd:null,
                goodCountStr:null,
                goodCountEnd:null,
                comCountStr:null,
                comCountEnd:null,
                isSelled:false
            },
            /******************
             * 一時変数
            ******************/
            tmpSellId:null,
            tmpComment:null,
            /******************
             * ページング設定
            ******************/
            currentPage: 1,
            perPage: 20,
            omatomeCurrentPage:1,
            perOmatomePage: 20
        }
  },
    components: {
        "vuejs-paginate": VueJsPaginate,
        Datepicker,
        VueLoading,
    },
  methods:{
    async setOmatome(done){
        let vm = this;
        vm.postOmatome.DONE = done
        var post = {...vm.postOmatome};
        delete post.user_name;
        await omatomeRepository.methods.Set(post).then(res=>{
            vm.$swal("登録しました", '',"success");
            vm.isOmatomeModal = false;
        });

    },
    async showOmatome(){
        let vm = this;
        if(vm.omatomeList.length == 0){
            vm.load = true;
            await vm.omatomeGet();
            vm.load = false;
        }
        vm.show_type='bundle';
    },
    GetCode(siteType, codeType){
        let vm = this;
        var rtnItem =  vm.baseCode.filter((item)=> {
            return item.SITE_TYPE == siteType && item.CODE_TYPE == codeType;
        });
        return rtnItem.sort( (a, b)=> {
            return a.CODE_ID - b.CODE_ID
        });
    },
    /**
     * ユーザーのおまとめ申請情報取得
     */
    async omatomeGet(){
        let vm = this;
        await omatomeRepository.methods.get().then(res=>{
            vm.omatomeList = res.data;
            for(var omatome of vm.omatomeList){
                var user = vm.userList.find(x=> x.USER_ID == omatome.USER_ID);
                var name = '';
                if(user) name = user.USER_NAME;
                omatome.user_name = name;
            };
            codeRepository.methods.GetCode().then(res=>{
                vm.baseCode = res.data;
                vm.codes.ShipMethodList       = vm.GetCode("m", "shipMethod");
                vm.codes.shiploadList         = vm.GetCode("m", "shipLoad");
                vm.codes.shipsorceList        = vm.GetCode("m", "shipSource");
                vm.codes.shipScheduleList     = vm.GetCode("m", "shipSchedule");
            });
            
            
        });
    },
    omatomeModal(item){
        let vm = this;
        vm.omatomeSellList = [];
        var tmpprice = item.SELL_PRICE.split(',');
        var tmpname = item.SELL_NAME.split(',');
        var tmpurl = item.SELL_ID.split(',');
        for(var i=0; i< tmpprice.length; i++){
            vm.omatomeSellList.push({
                price : tmpprice[i],
                name : tmpname[i],
                url : tmpurl[i],
            })
        }
        vm.postOmatome = item;
        vm.isOmatomeModal = true;
    },
    hideOmakseModal(){
        let vm = this;
        vm.isOmatomeModal = false;
    },
    allCheck(){
        let start = (this.currentPage - 1) * this.perPage;
        let end = this.currentPage * this.perPage;
        var items = this.tmpAuctionList.slice(start, end);
        for(var item of items){
            item.deleteFlg = true;            
        }
        this.tmpAuctionList.splice();
    },
    filter_comment_count(){
        let vm = this;
        vm.tmpAuctionList = [...vm.auctionList];
        vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
            return item.COMMENT_COUNT > 1
        });
        vm.isCommentFilter = true;
    },
    clear_comment_filter(){
        let vm = this;
        vm.tmpAuctionList = [...vm.auctionList];
        vm.isCommentFilter = false;
    },
    async delete_item(){
          let vm = this;
        var deleteArr = vm.tmpAuctionList.filter(x=> x.deleteFlg);

        var delList = deleteArr.map(x=> x.SELL_ID).join('\',\'');
        await cApiRepsitory.methods.post({
            "items":delList,
            "type":'deleteCom'
        }).then(res=>{
            vm.$swal("削除登録しました", '',"success")
            vm.tmpComList.comments = res.data
        })
    },
      returnPage(){
          let vm = this;
            vm.$router.back();
        },
        
      serch(){
        let vm = this;
        vm.tmpAuctionList = [...vm.auctionList];
        if(vm.serchItem.sellId){
        //出品IDフィルター
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return item.SELL_ID == vm.serchItem.sellId
            })
            
        }
        if(vm.serchItem.name){
            
            //名前フィルター
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return item.ITEM_TITLE.match(vm.serchItem.name) != null
            })
        }
        if(vm.serchItem.userName){
            
            //ユーザー名フィルター
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return item.USER_NAME == vm.serchItem.userName;
            })
        }
        if(vm.serchItem.sellDateStr){
            //出品日フィルター（開始）
            var str= moment(vm.serchItem.sellDateStr).format('YYYYMMDD');
            vm.tmpAuctionList = vm.tmpAuctionList.filter(function(item) {
                var putDate = moment(item.formatDate,"YYYY年 MM月 DD日").format('YYYYMMDD');
                return Number(putDate) >= Number(str) 
            });
        }
        if(vm.serchItem.sellDateEnd){
            //出品日フィルター（終了）
            var end= moment(vm.serchItem.sellDateEnd).format('YYYYMMDD');
            vm.tmpAuctionList = vm.tmpAuctionList.filter(function(item) {
                var putDate = moment(item.formatDate,"YYYY年 MM月 DD日").format('YYYYMMDD');
                return Number(putDate) <= Number(end) ;
            });
        }

        if(vm.serchItem.goodCountStr){
            //いいね数フィルター（開始）
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return Number(item.GOOD_COUNT) >= Number(vm.serchItem.goodCountStr);
            });
        }
        if(vm.serchItem.goodCountEnd){
            //いいね数フィルター（終了）
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item, i, arr)=> {
                return  Number(item.GOOD_COUNT) <= Number(vm.serchItem.goodCountEnd) ;
            });
        }
        if(vm.serchItem.comCountStr){
            //コメント数フィルター（開始）
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item)=> {
                return Number(item.COMMENT_COUNT) >= Number(vm.serchItem.comCountStr);
            });
        }
        if(vm.serchItem.comCountEnd){
            //コメント数フィルター（終了）
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item)=> {
                return Number(item.COMMENT_COUNT) <= Number(vm.serchItem.comCountEND) ;
            });
        }

        if(vm.serchItem.comDateStr){
            //最新コメント日フィルター（開始）
            var str= moment(vm.serchItem.comDateStr).format('YYYYMMDD');
            vm.tmpAuctionList = vm.tmpAuctionList.filter(function(item) {
                
                return item.COMMENT_DAY != "-" && Number(moment(item.COMMENT_DAY,"YYYY年 MM月 DD日").format("YYYYMMDD")) >= Number(str);
            });
        }
        if(vm.serchItem.comDateEnd){
            //最新コメント日フィルター（終了）
            var end= moment(vm.serchItem.comDateEnd).format('YYYYMMDD');
            vm.tmpAuctionList = vm.tmpAuctionList.filter(function(item) {
                return item.COMMENT_DAY != "-" && Number(moment(item.COMMENT_DAY,"YYYY年 MM月 DD日").format("YYYYMMDD")) <= Number(end);
            });
        }

        if(vm.serchItem.isSelled){
            //成約済みのみフィルター
            vm.tmpAuctionList = vm.tmpAuctionList.filter((item)=> {
                return item.IS_SELLED
            });
        }
    },
    clear(){
        this.tmpAuctionList = [...this.auctionList];
        this.serchItem ={};
    },
    paginateClickCallback (pageNum) {
        this.currentPage = Number(pageNum);
    },
    omatomePaginateClickCallback (pageNum) {
        this.omatomeCurrentPage = Number(pageNum);
    },
    rePage(){
        var vm = this;
        vm.postItem = {};
        vm.tmpComList.comments = [];
        this.isModal = false;
    },
    async modal(item){
        let vm = this;
        vm.tmpComList =item;
        vm.postItem = {
            price : item.SELL_PRICE,
            title : item.TITLE
        }
        await cApiRepsitory.methods.post({
            "item_id":item.SELL_ID,
            "type":'getComments'
        }).then(res=>{
            vm.tmpComList.comments = res.data
        })
        vm.isModal = true;
    },
    setComment(){
        let vm = this;
        var item = vm.tmpComList;
        cApiRepsitory.methods.post({
            "user_id":item.USER_ID,
            "type":"setComment",
            "itemId":item.SELL_ID,
            "comment":vm.postItem.com
        }).then(res=>{
            vm.$swal("コメント返信登録しました。", '',"success")
            vm.postItem = {};
            vm.tmpComList = [];
        vm.isModal = false;
        });

    },
    editItem(){
        let vm = this;
        var item = vm.tmpComList;
        cApiRepsitory.methods.post({
            "user_id":item.USER_ID,
            "type":"editItem",
            "itemId":item.SELL_ID,
            "title":vm.postItem.title,
            "price":vm.postItem.price
        }).then(res=>{
            vm.$swal("商品情報を登録しました。", '',"success")
            console.log(res);
            vm.tmpComList = [];
            vm.postItem = {};
            
            vm.isModal = false;
        });
    },    
    async init() {
    let vm = this;
    userRepository.methods.getChild()
    .then(async res => {
        var data = res.data;
        vm.userList = data;

        // ユーザーIDをリストにまとめる
        let userIds = data.map(user => user.USER_ID);

        // まとめてAPIリクエストを送信する
        let response = await cApiRepsitory.methods.post({
            "user_ids": userIds,
            "type": "getCommentsBatch"
        });

        // レスポンスの確認
        if (!Array.isArray(response.data)) {
            console.error('Response data is not an array:', response.data);
            return;
        }

        let r = response.data;

        // auctionListの初期化
        this.auctionList = [];

        // レスポンスの処理
        r.forEach(item => {
            if (item && typeof item === 'object') {
                this.auctionList.push(item);
            } else {
                console.warn('Expected an object but got:', item);
            }
        });

        // ユーザー名の追加
        for (let i = 0; i < this.auctionList.length; i++) {
            let user = vm.userList.find(x => x.USER_ID === this.auctionList[i].USER_ID);
            this.auctionList[i].user_name = user ? user.USER_NAME : 'Unknown';
        }

        // auctionListのソート
        this.auctionList = this.auctionList.sort(function(a, b) {
            let bRep = b.COMMENT_DATE.replace('年', '/').replace('月', '/').replace('日', '').replace('時', ':').replace('分', '');
            let aRep = a.COMMENT_DATE.replace('年', '/').replace('月', '/').replace('日', '').replace('時', ':').replace('分', '');
            return Date.parse(bRep) - Date.parse(aRep);
        });

        vm.tmpAuctionList = this.auctionList;
    });
}

  },
  computed:{
        sum() {
            return this.tmpAuctionList.reduce((sum, item) => {
                if(item.IS_SELLED){
                    sum += Number(item.SELL_PRICE);
                }
                return sum
            }, 0);
        },
        getPaginateCount: function () {
            return Math.ceil(this.tmpAuctionList.length / this.perPage);
        },
        getItems () {
            if(!this.auctionList.length) return;
            if(this.auctionList.length == 0) return;
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            return this.tmpAuctionList.slice(start, end);
        },
        getOmatomePaginateCount: function () {
            return Math.ceil(this.omatomeList.length / this.perOmatomePage);
        },
        getOmatomeItems () {
            if(!this.omatomeList.length) return;
            if(this.omatomeList.length == 0) return;
            let start = (this.omatomeCurrentPage - 1) * this.perOmatomePage;
            let end = this.omatomeCurrentPage * this.perOmatomePage;
            return this.omatomeList.slice(start, end);
        }
    },
   created:async function(){
        let vm =this;
        await vm.init();

  }
}
</script>

<style lang="scss">
@import "../style/sell.scss";
    
    @import "../style/auctionRegister.scss";
</style>